/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<JobPosition>, schemaOptions: { partial: true })
 */
export interface JobPositionPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    name?: string;
    leadershipPosition?: string;
    positionObjective?: string;
    responsibilities?: string;
    levelResponsibilityId?: string;
    makeDecisions?: boolean;
    hasPersonnelUnderCharge?: boolean;
    numberOfEmployeesDirect?: number;
    numberOfEmployeesIndirect?: number;
    positionDependPositions?: string;
    canControlBudgets?: boolean;
    amount?: number;
    informationAdditional?: string;
    ageMin?: number;
    ageMax?: number;
    businessTrips?: number;
    professionalGraduateId?: string;
    areaOrSpecialty?: string;
    specificExpertiseRequired?: string;
    language?: string;
    technicalTools?: string;
    languageOrPrograms?: string;
    statusId?: string;
    code?: string;
    companyId?: string;
    departmentId?: string;
    areaId?: string;
    genreId?: string;
    maritalStatusId?: string;
    academicLevelId?: string;
}

